// extracted by mini-css-extract-plugin
module.exports = {"submitContainer":"Contacts_submitContainer__2wFYF","boxContainer":"Contacts_boxContainer__4g7Xf"};